import React from "React"
import PropTypes from "prop-types"


const FootNote = ({children}) => {
  return (
    <div className="foot-note center">{children}</div>
  )
}

FootNote.propTypes = {
  children: PropTypes.node.isRequired,
}

export default FootNote
